// extracted by mini-css-extract-plugin
export default {"upgradeBadge":"hmhBFyGm9VUtqRHiFgNs"};